<div class="ap-margin-bottom-3">
    {{ 'extra-asset.own-property.button' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>

<ap-button-group id="ownProperty" [formControl]="mainApplicantControl" (buttonGroupClicked)="onButtonGroupClicked($event)">
    <ap-button-group-item label="{{ 'general.button-group.yes' | apContent }}" value="true"> </ap-button-group-item>
    <ap-button-group-item label="{{ 'general.button-group.no' | apContent }}" value="false"> </ap-button-group-item>
</ap-button-group>

<additional-info
    [key]="questionKey"
    titleKey="extra-asset.own-property.button.additional-info.text"
    contentKey="extra-asset.own-property.button.additional-info.content"
    modalUrlKey="extra-asset.own-property.button.additional-info.text"
></additional-info>
